import { Link } from 'react-router-dom';

export default function BrandMark({ to = '/', compact = false }) {
  return (
    <Link to={to} className="group flex items-center gap-2.5 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold">
      <img
        src="/icons/ummah-medallion.svg"
        alt=""
        width={compact ? 32 : 36}
        height={compact ? 32 : 36}
        className={compact ? 'h-8 w-8' : 'h-9 w-9'}
      />
      <span className="flex flex-col">
        <span className="font-display text-[1.15rem] font-bold leading-none tracking-tight text-masjid">
          Islamic Scholars
        </span>
        <span className="mt-1 h-px w-12 bg-gold-300 transition-all group-hover:w-full" />
      </span>
    </Link>
  );
}
